import { useIsMultiEntityEnabled } from './useIsMultiEntityEnabled'
import { useIsSuperuser } from './useIsSuperuser'

/**
 * Single source of truth for whether Multi-Entity FE surfaces should render:
 * PLAT_4870_MULTI_ENTITY flag AND multi_entity_enabled switch AND Super User.
 *
 * Layers the Super-User gate on top of `useIsMultiEntityEnabled` (flag AND
 * switch) rather than mutating it — its flag-AND-switch semantics are relied on
 * by IAM category-selection and import surfaces that must not gain a Super-User
 * requirement.
 */
export const useCanAccessMultiEntity = (): boolean => {
  const isMultiEntityEnabled = useIsMultiEntityEnabled()
  const isSuperuser = useIsSuperuser()

  return isMultiEntityEnabled && isSuperuser
}
